import type { SearchMatch } from '@vivport/backend/types';
import { describeSearchLocatorChip, splitSnippetMarks } from '@/utils/search-match-utils';

export function ExploreMatchLine({ match }: { match: SearchMatch }) {
  const chip = describeSearchLocatorChip(match);
  const parts = match.snippet ? splitSnippetMarks(match.snippet) : [];
  if (chip === null && parts.length === 0) {
    return null;
  }
  return (
    <div
      data-testid="explore-match"
      className="flex min-w-0 items-baseline gap-2 text-sm text-muted-foreground"
    >
      {chip ? (
        <span className="shrink-0 rounded border border-border px-1.5 text-xs leading-5 text-muted-foreground">
          {chip}
        </span>
      ) : null}
      {parts.length > 0 ? (
        <span className="line-clamp-2 min-w-0 break-words">
          {parts.map((part, index) =>
            part.marked ? (
              <mark key={index} className="rounded-sm bg-highlight px-0.5 text-highlight-foreground">
                {part.text}
              </mark>
            ) : (
              <span key={index}>{part.text}</span>
            )
          )}
        </span>
      ) : null}
    </div>
  );
}
